class ReadMoreDesktop extends window.BAO.CustomElement() {
  static get requiredAttributes () {
    return [
      'data-read-more-desktop-translation-read-more',
      'data-read-more-desktop-translation-read-less',
    ]
  }

  static get requiredElements () {
    return ['trigger', 'text']
  }

  static get requiredExternalElements () {
    return ['container']
  }

  connectedCallback () {
    super.connectedCallback()

    this.handleTruncation()
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(this, 'click', this.handleClick.bind(this))

    this.listeners.add(window, 'resize', this.handleResize.bind(this))
  }

  handleTruncation () {
    const textElement = this.els.text.element

    textElement.classList.add('clc-MakersHero_TextContentInner-truncate')

    if (this.getLineCount(textElement) <= 2) {
      textElement.classList.remove('clc-MakersHero_TextContentInner-truncate')
      this.els.trigger.element.style.display = 'none'
      return
    }

    this.els.trigger.element.style.display = 'block'
    this.els.trigger.element.textContent = this.dataset.readMoreDesktopTranslationReadMore
  }

  handleResize () {
    this.els.text.element.classList.remove(
      'clc-MakersHero_TextContentInner-truncate',
    )
    this.handleTruncation()
    this.unfreezeMediaHeight()
  }

  freezeMediaHeight () {
    if (!this.externalEls.media?.exists) return

    const media = this.externalEls.media.element
    const mediaBounds = media.getBoundingClientRect()

    media.style.height = `${mediaBounds.height}px`
    media.style.alignSelf = 'start'
  }

  unfreezeMediaHeight () {
    if (!this.externalEls.media?.exists) return

    const media = this.externalEls.media.element

    media.style.height = ''
    media.style.alignSelf = ''
  }

  getLineCount (el) {
    const style = window.getComputedStyle(el)
    const lineHeight = parseFloat(style.lineHeight)

    // If line-height is "normal", compute an approximate value
    const actualLineHeight = isNaN(lineHeight)
      ? parseFloat(style.fontSize) * 1.2
      : lineHeight

    return Math.round(el.scrollHeight / actualLineHeight)
  }

  handleClick () {
    const textElement = this.els.text.element
    const isTruncated = textElement.classList.contains(
      'clc-MakersHero_TextContentInner-truncate',
    )

    const container = this.externalEls.container.element
    const containerBounds = container.getBoundingClientRect()

    const content = this.externalEls.content.element
    const contentBounds = content.getBoundingClientRect()

    if (isTruncated === true) {
      this.freezeMediaHeight()

      textElement.classList.remove('clc-MakersHero_TextContentInner-truncate')

      const offsetTop =
        contentBounds.top -
        (containerBounds.top +
          parseFloat(
            getComputedStyle(container).getPropertyValue('padding-block-start'),
          ))

      container.style.alignItems = 'flex-start'
      content.style.marginBlockStart = `${offsetTop}px`
    } else {
      textElement.classList.add('clc-MakersHero_TextContentInner-truncate')

      container.style.alignItems = 'center'
      content.style.marginBlockStart = 0

      this.unfreezeMediaHeight()
    }

    const truncated = textElement.classList.contains(
      'clc-MakersHero_TextContentInner-truncate',
    )

    this.els.trigger.element.textContent = truncated
      ? this.dataset.readMoreDesktopTranslationReadMore
      : this.dataset.readMoreDesktopTranslationReadLess
  }
}

if (!customElements.get('read-more-desktop')) {
  customElements.define('read-more-desktop', ReadMoreDesktop)
}
